// extracted by mini-css-extract-plugin
export default {"img":"NoDataImage_img__qLZBn","container":"NoDataImage_container__NfdhY","letsGoButton":"NoDataImage_letsGoButton__JeUdo"};